// @flow

import * as React from 'react';

type Props = {
  width?: string,
  height?: string,
  color?: string,
};

export const Watch = ({ width, height, color }: Props) => (
  <svg
    viewBox="0 0 500 500"
    width={width || '100%'}
    height={height || '100%'}
    style={{ fill: color || '#003F63' }}
  >
    <path d="M250,0C112.5,0,0,112.5,0,250s112.5,250,250,250s250-112.5,250-250S387.5,0,250,0z M250,468.8 c-121.9,0-218.8-96.9-218.8-218.8S128.1,31.2,250,31.2S468.8,128.1,468.8,250S371.9,468.8,250,468.8z" />
    <path d="M255.6,156.2c-9.3,0-15.6,28.2-15.6,62.5c0,11.8,0.7,23,2.1,32.4c-5.5-0.7-11.6-1.1-17.8-1.1 c-25,0-46.9,6.2-46.9,15.6c0,9.3,21.9,15.6,46.9,15.6c9.7,0,18.9-0.9,26.6-2.6c1.5,1.7,3.1,2.6,4.7,2.6c2.7,0,5.1-2.3,7.2-6.5 c5.3-2.5,8.4-5.6,8.4-9.1c0-2.2-1.3-4.3-3.6-6.2c2.3-11,3.6-25.2,3.6-40.7C271.2,184.3,265,156.2,255.6,156.2z" />
  </svg>
);
